import { useTranslation } from "react-i18next";
import { Editor } from "@tiptap/react";
import { mdiFormatBold } from "@mdi/js";
import { FormattingToggle } from "./FormattingToggle";

type Props = {
  editor: Editor;
};

export function BoldFormattingToggle({ editor }: Props) {
  const { t } = useTranslation();

  return (
    <FormattingToggle
      icon={mdiFormatBold}
      tooltip={t("BoldFormattingToggle.tooltip")}
      pressed={editor.isActive("bold")}
      onPressedChange={() => editor.chain().focus().toggleBold().run()}
    />
  );
}
